import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';

import {Constants} from '../../../shared/config/constants.config';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {MasterService} from '../../../shared/services/master.service';
import {NotificationsService} from '../../../shared/services/notification.service';
import {ProfilesComponent} from '../profiles/profiles.component';

@Component({
    selector: 'app-profiles-recovery-modal',
    templateUrl: './profiles-recovery.component.html',
    styleUrls: ['./profiles-recovery.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilesRecoveryModalComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    profilesComponent: ProfilesComponent;

    recoveryForm: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email])
    });

    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly masterService: MasterService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly notificationService: NotificationsService,
    ) {
    }

    onClose() {
        this.bsModalRef.hide();
    }

    onRecover() {
        const email: string = this.recoveryForm.controls['email'].value;

        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.masterService.addSubAccount(email).subscribe(() => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.onClose();

            // Reload the whole page to refresh the profiles data
            setTimeout(() => {
                window.location.reload();
            }, 500);

            this.notificationService.success('Потребителят е успешно възстановен!');
        }, (err: HttpErrorResponse) => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

            if (err.status === 404) {
                this.notificationService.error('Потребител с този E-Mail адрес не съществува.');
            } else if (err.status === 400) {
                this.notificationService.error('Този потребител вече е свързан към друг мастър профил.');
            } else {
                this.notificationService.error('Възникна грешка при възстановяването на потребителя.');
            }
        });
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }
} 